import { Box, Text } from '@mantine/core'

interface NoDataAvailableProps {
  message?: string
}

export function NoDataAvailable({ message = 'No data currently available' }: NoDataAvailableProps) {
  return (
    <Box h={300} w="100%" display="flex" flex={1} style={{ justifyContent: 'center', alignItems: 'center' }}>
      <Text c="dimmed">{message}</Text>
    </Box>
  )
}
